;(function () {
  'use strict';

  /**
   * ログアウトモーダル
   */
  var logoutModal = {
    /**
     * 初期化
     */
    init: function (options) {
      var config = $.extend({
        dialog: '.ui-dialog--logout',             // ダイアログのセレクタ
        sideMargen: 15,                           // 左右の余白 [px]
        openButton: '.js-dialog--logout__open',   // ダイアログの表示ボタン
        closeButton: '.js-dialog--logout__close', // ダイアログの非表示ボタン
        logoutButton: '#js-dialog-logout'         // ログアウトボタン
      }, options);

      if ($('body.sp-viewport').length) {
        // sp版のモーダル設定
        $(config.dialog).dialog({
          autoOpen: false,
          draggable: false,
          resizable: false,
          modal: true,
          width: $(window).width() - (config.sideMargen * 2),
          position: {
            my: 'center',
            at: 'center',
            of: window
          },
          dialogClass: 'dialog-logout',
          show: 'fade',
          hide: 'fast'
        });
      } else {
        // pc版のモーダル設定
        $(config.dialog).dialog({
          autoOpen: false,
          draggable: false,
          resizable: false,
          modal: true,
          width: 300,
          position: {
            my: 'center',
            at: 'center',
            of: window
          },
          dialogClass: 'dialog-logout',
          show: 'fade',
          hide: 'fast'
        });
      }

      /**
       * ログアウトモーダル 表示イベント
       */
      $(config.openButton).on('click', function () {
        $(config.dialog).dialog('open');
        return false;
      });

      /**
       * ログアウトモーダル 非表示イベント
       */
      $(config.closeButton).on('click', function () {
        $(config.dialog).dialog('close');
        return false;
      });

      /**
       * ログアウト（モーダル 非表示イベント）
       * リンク（ログアウト処理）が止まってしまうため、return false しない
       */
      $(config.logoutButton).on('click', function () {
        $(config.dialog).dialog('close');
      });
    }
  };


  /**
   * DOM content loaded
   */
  $(function () {
    logoutModal.init();
  });
}.call(this));
